import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { IMatrizDeImpacto, IRodada, RodadaService } from 'src/app/shared/api/testes/rodada.service';
import { ITeste } from 'src/app/shared/api/testes/testes.service';
import { IActionsCardbotoes } from 'src/app/shared/components/card-botoes/card-botoes.component';
import { FormularioDinamicoComponent } from 'src/app/shared/components/formulario-dinamico/formulario-dinamico.component';
import { IDialogData, ModalComponent } from 'src/app/shared/components/modal/modal.component';
import { ConfigurationColumn } from 'src/app/shared/model/resource';
import { DialogService } from 'src/app/shared/services/dialog.service';
import { NotificationService } from 'src/app/shared/services/notificationService';
import { rodadaResource } from './rodada.resource';

@Component({
    selector: 'rodadas',
    templateUrl: './rodadas.component.html',
    styleUrls: ['./rodadas.component.css']
})
export class RodadasComponent implements OnInit, OnDestroy {
    @ViewChild('modal') modal!: ModalComponent;
    @ViewChild('formularioRodada') formularioRodada!: FormularioDinamicoComponent;

    @Input() idTeste!: string;
    @Input() idModulo!: string;
    @Input() teste!: ITeste;

    rodadaResouce = rodadaResource;
    colunasFormularioRodada: ConfigurationColumn[] = [];
    dataModal: IDialogData = { titulo: '' };
    showFormModal = false;

    actions: IActionsCardbotoes[] = [];
    entidadeRodada!: any;
    listaRodadas: any = [];

    readonly ADICIONAR_RODADA = 'Adicionar ' + rodadaResource.nomeEntidade.singular;
    readonly EDITAR_RODADA = 'Editar ' + rodadaResource.nomeEntidade.singular;
    readonly EXCLUIR_RODADA = 'Excluir ' + rodadaResource.nomeEntidade.singular;

    private _subscriberListagemRodadas: Subscription | null = null;
    private _subscriberModal: Subscription | null = null;
    private _subscriberCreateRodada: Subscription | null = null;

    constructor(
        public rodadaService: RodadaService,
        private notify: NotificationService,
        private dialog: DialogService
    ) {}

    ngOnInit(): void {
        this.setarIdsNaCamadaDeServico();

        this.actions.push({
            hint: this.EDITAR_RODADA,
            icon: 'edit',
            text: this.EDITAR_RODADA,
            type: 'primary',
            onClick: this.abrirModalEditarRodada
        });

        this.actions.push({
            hint: this.EXCLUIR_RODADA,
            icon: 'delete',
            text: this.EXCLUIR_RODADA,
            type: 'warn',
            onClick: this.excluirRodada
        });

        this.listarRodadas();
    }

    private setarIdsNaCamadaDeServico() {
        // é importante setar esses valores a cada vez que o serviço for chamado
        // pois esse componente pode estar sendo chamado mais de uma vez na mesma tela com id diferente
        this.rodadaService.setBaseUrl(this.idTeste, this.idModulo);
    }

    ngOnDestroy(): void {
        if (this._subscriberListagemRodadas) this._subscriberListagemRodadas.unsubscribe();
        if (this._subscriberModal) this._subscriberModal.unsubscribe();
        if (this._subscriberCreateRodada) this._subscriberCreateRodada.unsubscribe();
    }

    listarRodadas() {
        this.setarIdsNaCamadaDeServico();
        this._subscriberListagemRodadas = this.rodadaService
            .get({ tamanho: 999 })
            .subscribe((response) => {
                this.listaRodadas = this.formatarRodadas(response.resultados);
            });
    }

    private formatarRodadas(rodadas: IRodada[]) {
        return rodadas.map(rodada => {
            return {
                ...rodada,
                ...this.getMatrizImpactoFormatada(rodada)
            }
        })
    }

    private getMatrizImpactoFormatada(rodada: IRodada){
        const vazioOuNulo = (valor: any) => this.isEmpty(valor) ? undefined : valor;

        if(!rodada.matriz_de_impacto) return;

        const matrizImpacto = {
            '0_a_50_vulnerabilidade': vazioOuNulo(rodada.matriz_de_impacto['0_a_50']?.vulnerabilidade),
            '0_a_50_recomendacao': vazioOuNulo(rodada.matriz_de_impacto['0_a_50']?.recomendacao),
            '51_a_70_vulnerabilidade': vazioOuNulo(rodada.matriz_de_impacto['51_a_70']?.vulnerabilidade),
            '51_a_70_recomendacao': vazioOuNulo(rodada.matriz_de_impacto['51_a_70']?.recomendacao),
            '71_a_100_vulnerabilidade': vazioOuNulo(rodada.matriz_de_impacto['71_a_100']?.vulnerabilidade),
            '71_a_100_recomendacao': vazioOuNulo(rodada.matriz_de_impacto['71_a_100']?.recomendacao),
        };

        return matrizImpacto;
    }

    excluirRodada = (entity: IRodada) => {
        this.dialog
            .confirm('Tem certeza que deseja excluir a rodada selecionada?', entity.nome)
            .subscribe({
                next: (confirmed) => {
                    if (confirmed) {
                        this.setarIdsNaCamadaDeServico();
                        this.rodadaService.delete(entity.uuid).subscribe({
                            next: (response) => {
                                this.listarRodadas();
                            }
                        });
                    }
                }
            });
    };

    showModalFormularioRodada() {
        this.showFormModal = true;
        this._subscriberModal = this.modal
            .open({ width: '40em' })
            .afterClosed()
            .subscribe({
                next: () => {
                    this.showFormModal = false;
                }
            });
    }

    abrirModalCriarRodada() {
        this.entidadeRodada = {};
        this.dataModal.titulo = this.ADICIONAR_RODADA;
        this.colunasFormularioRodada = this.rodadaResouce.colunas.filter(
            (c) => !c.unAvailableOnCreate
        );
        this.showModalFormularioRodada();
    }

    abrirModalEditarRodada = (entity: IRodada) => {
        this.entidadeRodada = entity;
        // debugger;
        this.dataModal.titulo = this.EDITAR_RODADA;
        this.colunasFormularioRodada = this.rodadaResouce.colunas.filter((c) => c);
        this.showModalFormularioRodada();
    };

    private isEmpty(value: any) {
        return value == '' || value == null || value == undefined;
    }

    private getMatrizDeImpacto(rodada: any) : IMatrizDeImpacto | undefined {
        const vazioOuNulo = (valor: any) => this.isEmpty(valor) ? undefined : valor;

        const matrizImpacto: IMatrizDeImpacto = {
            '0_a_50': {
                vulnerabilidade: vazioOuNulo(rodada['0_a_50_vulnerabilidade']),
                recomendacao: vazioOuNulo(rodada['0_a_50_recomendacao'])
            },
            '51_a_70': {
                vulnerabilidade: vazioOuNulo(rodada['51_a_70_vulnerabilidade']),
                recomendacao: vazioOuNulo(rodada['51_a_70_recomendacao'])
            },
            '71_a_100': {
                vulnerabilidade: vazioOuNulo(rodada['71_a_100_vulnerabilidade']),
                recomendacao: vazioOuNulo(rodada['71_a_100_recomendacao'])
            }
        };

        const campos = [
            matrizImpacto['0_a_50'].recomendacao,
            matrizImpacto['0_a_50'].vulnerabilidade,
            matrizImpacto['51_a_70'].recomendacao,
            matrizImpacto['51_a_70'].vulnerabilidade,
            matrizImpacto['71_a_100'].recomendacao,
            matrizImpacto['71_a_100'].vulnerabilidade
        ];

        const todosVazios = campos.every((campo) => this.isEmpty(campo));
        const todosPreenchidos = campos.every((campo) => !this.isEmpty(campo));

        const valido = todosVazios || todosPreenchidos;

        if(!valido){
            const erro = 'Caso preencha um campo da matriz de impacto, então deve-se preencher todos os campos. Caso contrário, deixe todos os campos vazios.'
            this.notify.error(erro);
            throw new Error(erro);
        }
        if(todosVazios) return undefined;
        return matrizImpacto;
    }

    onSaveRodada() {
        return new Observable((observer) => {
            if (!this.formularioRodada.isValid()) {
                observer.error();
                return;
            }

            this.setarIdsNaCamadaDeServico();
            const rodada = this.formularioRodada.getDadosFormularioSalvar();

            const matrizImpacto = this.getMatrizDeImpacto(rodada);

            const rodadaSalvar: IRodada = {
                descricao: rodada.descricao,
                modulo: rodada.modulo,
                nome: rodada.nome,
                posicao: rodada.posicao,
                uuid: rodada.uuid,
                matriz_de_impacto: matrizImpacto
            };

            let createOrSaveRequest = null;
            if (this.entidadeRodada?.uuid) {
                createOrSaveRequest = this.rodadaService.update(
                    this.entidadeRodada.uuid,
                    rodadaSalvar
                );
            } else {
                createOrSaveRequest = this.rodadaService.create(rodadaSalvar);
            }

            this._subscriberCreateRodada = createOrSaveRequest.subscribe({
                next: () => {
                    this.listarRodadas();
                    observer.next();
                },
                error: (e: any) => {
                    this.formularioRodada.tratarErroRequisicao(e);
                    this.notify.error(e.error.erro);
                    observer.error();
                }
            });
        });
    }
}
